import { render, staticRenderFns } from "./couponItem.vue?vue&type=template&id=0ab8c8ea&scoped=true"
import script from "./couponItem.vue?vue&type=script&lang=js"
export * from "./couponItem.vue?vue&type=script&lang=js"
import style0 from "./couponItem.vue?vue&type=style&index=0&id=0ab8c8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8c8ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CouponModal: require('/drone/src/components/CouponModal/index.vue').default})
